/** Günlük takvim: K=kopyala, T=taşı sürükle-bırak tipleri ve yardımcılar. */

export type AppointmentDragMode = "copy" | "move";

export type AppointmentDragSource = {
  appointmentId: string;
  studentId: string;
  studentName?: string | null;
  instructorId: string;
  vehicleId: string;
  lessonType: string;
  sourceDate: string;
  sourceStart: string;
  sourceEnd: string;
};

export type AppointmentDragDropTarget = {
  mode: AppointmentDragMode;
  source: AppointmentDragSource;
  date: string;
  startHHmm: string;
  endHHmm: string;
  instructorId: string;
  instructorName: string;
};

export type AppointmentConflictRow = {
  conflict_type?: string;
  conflict_reason?: string;
  starts_at?: string;
  ends_at?: string;
};

export function buildIsoDateTime(date: string, hhmm: string): string {
  const t = hhmm.length >= 5 ? hhmm.slice(0, 5) : hhmm;
  return `${date}T${t}:00+03:00`;
}

export function normalizeDragLessonType(value: string): "normal" | "special" | "extra" {
  if (value === "special" || value === "extra") return value;
  return "normal";
}

/** Yalnızca araç değiştirerek çözülebilecek çakışmalar. */
export function canResolveByChangingVehicle(conflicts: AppointmentConflictRow[]): boolean {
  if (!conflicts.length) return false;
  return conflicts.every((c) => {
    const reason = String(c.conflict_reason || "");
    const type = String(c.conflict_type || "");
    if (type === "vehicle_unavailability") return true;
    if (reason === "same_vehicle") return true;
    return false;
  });
}

export function formatConflictMessage(conflicts: AppointmentConflictRow[], fallback?: string): string {
  if (!conflicts.length) {
    return fallback || "Bu zaman diliminde çakışma var.";
  }
  const labels = new Set<string>();
  for (const c of conflicts) {
    const reason = String(c.conflict_reason || "");
    const type = String(c.conflict_type || "");
    if (
      type === "instructor_leave" ||
      reason === "instructor_on_leave" ||
      reason === "instructor_weekly_leave"
    ) {
      labels.add("Eğitmen izinli");
      continue;
    }
    if (type === "vehicle_unavailability") {
      labels.add("Araç müsait değil");
      continue;
    }
    if (reason === "same_instructor" || reason === "same_instructor_and_vehicle") {
      labels.add("Hoca uygun değil (dolu)");
    }
    if (reason === "same_vehicle" || reason === "same_instructor_and_vehicle") {
      labels.add("Araç uygun değil (dolu)");
    }
    if (
      reason === "same_student" ||
      reason === "same_student_and_instructor" ||
      reason === "same_student_and_vehicle" ||
      reason === "same_student_instructor_and_vehicle"
    ) {
      labels.add("Kursiyer bu saatte başka randevuya sahip");
    }
    if (!reason && !type) labels.add("Çakışma");
  }
  if (labels.size === 0) return fallback || "Bu zaman diliminde çakışma var.";
  return [...labels].join(" · ");
}

export function isDraggableReservationStatus(status: string): boolean {
  return status === "planned" || status === "in_progress";
}
